import { ENGAGEMENTS, FORUMS, POLICY } from "../../data/content";

export const Engagements = () => (
  <section className="bg-[#F5F5F0] text-[#111111]" data-testid="engagements-section">
    <div className="px-6 lg:px-12 py-24 lg:py-28 grid lg:grid-cols-2 gap-16 border-b border-black/10">
      <div>
        <p className="font-mono text-xs tracking-[0.35em] text-black/50 flex items-center gap-4">
          SELECTED FORUMS <span className="inline-block w-16 h-px bg-black/30" />
        </p>
        <div className="mt-10 space-y-8">
          {FORUMS.map((f) => (
            <a
              key={f.title}
              href={f.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`forum-${f.label.toLowerCase().replace(/\\s+/g, "-")}`}
              className="group block border-l-2 border-black/20 pl-6 hover:border-black transition-colors duration-300"
            >
              <p className="font-mono text-[10px] tracking-[0.3em] text-black/50">{f.label}</p>
              <h3 className="mt-2 font-display text-2xl leading-snug group-hover:underline underline-offset-4">
                {f.title}
              </h3>
              <p className="mt-1 text-sm text-black/60">{f.meta}</p>
            </a>
          ))}
        </div>
      </div>
      <div>
        <p className="font-mono text-xs tracking-[0.35em] text-black/50 flex items-center gap-4">
          POLICY CONTRIBUTIONS <span className="inline-block w-16 h-px bg-black/30" />
        </p>
        <ul className="mt-10 divide-y divide-black/10 border-y border-black/10" data-testid="policy-list">
          {POLICY.map((p) => (
            <li key={p} className="flex items-center justify-between py-5">
              <span className="font-display text-xl lg:text-2xl">{p}</span>
              <span className="font-mono text-[10px] tracking-[0.25em] text-black/40">PDF · DOCUMENT</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="px-6 lg:px-12 py-14">
      <p className="font-mono text-xs tracking-[0.35em] text-black/50 flex items-center gap-4 mb-10">
        INSTITUTIONAL ENGAGEMENTS <span className="inline-block w-16 h-px bg-black/30" />
      </p>
      <div className="flex flex-wrap items-baseline gap-x-12 gap-y-6" data-testid="engagement-marks">
        {ENGAGEMENTS.map((e) => (
          <span key={e} className="font-display text-xl lg:text-2xl tracking-wide text-black/70">
            {e}
          </span>
        ))}
      </div>
    </div>
  </section>
);
